import { Component, OnInit, ViewChild } from '@angular/core';
import { FormCanDeactivate } from '../../../_guards/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { FormRestrictionDefiningViewModel } from '../../settings/setting.class';
import { Subject, Subscription } from 'rxjs';
import { DuePaymentsViewModel, ItemViewModel } from '../payments-model';
import { PaymentsService } from '../payments.service';
import { NotificationService } from '../../../_services/notification.service';
import { ClientService } from '../../clients/clients.service';
import { ExpenseServices } from '../../expense/expense-services';
import { ActivatedRoute } from '@angular/router';
import { LocalService } from '../../../_services/local.service';
import { debounceTime } from 'rxjs/operators';
import { StoreService } from '../../store/store.services';

@Component({
  selector: 'app-payment-installment',
  templateUrl: './payment-installment.component.html',
  styleUrls: ['./payment-installment.component.scss']
})
export class PaymentInstallmentComponent extends FormCanDeactivate implements OnInit {
  @ViewChild("f")
  form: NgForm;
  name = "slideToggle";
  id = "materialSlideToggle";
  checked = false;
  disabled = false;
  label = "Toggle On/Off";
  labelledby = "Some Other Text";
  public FormVm: FormRestrictionDefiningViewModel = new FormRestrictionDefiningViewModel();
  public mast: DuePaymentsViewModel = new DuePaymentsViewModel();
  public saving = false;
  public feachting = false;
  public searchEvent = new Subject<any>();
  public searchSubcription: Subscription = null;
  public accountList: any[] = [];
  public typeList: any[] = [];
  public modeList: any[] = [];
  public NetAmount = 0;
  public RemainingNetAmount = 0;
  public RemainingNetAmountBackUp = 0;
  private _isEdit = false;
  public _MaxDateToday = new Date();
  public FromDate: any = null;
  public ToDate: any = null;
  public paymentList: DuePaymentsViewModel[] = [];
  public paymentListCount: number = 0;
  public showError: boolean = false;
  public errorMessages: { [key: number]: boolean } = {};
  public selectedType: any;
  public selectedMode: ItemViewModel = new ItemViewModel();
  public isMate: boolean = true;
  public supaccountList = [];
  public paymentMasterId: number = 0;
  public invoiceId: number = 0;
  public paymentMaster: any;
  constructor(
    public _paymentsService: PaymentsService,
    public _notificationService: NotificationService,
    public _clientService: ClientService,
    private activatedRoute: ActivatedRoute,
    private _localService: LocalService,
    public _storeService: StoreService,
  ) {
    super();
    this.activatedRoute.queryParams.subscribe(params => {
      this.paymentMasterId= params['id'];
      this.invoiceId= params['Inv'];
    });
    if(this.paymentMasterId == undefined){
      this.paymentMasterId = 0;
    }
    if(this.invoiceId == undefined){
      this.invoiceId = 0;
    }
  }

  ngOnInit() {

    this.handleSearchEvents();
    this.mast.CreatedDate = new Date();


    this.getAccount(` `, `SCSC`);
    this.getAccount(' ', 'CaB');
    this.typeList = [
      { Name: 'Sale Form' },
      { Name: 'Purchase Form' },
      { Name: 'Vehicle Rent' },
      { Name: 'Rent Invoice' },
      { Name: 'DH Commission' },
      { Name: 'DHN Commission' },
      { Name: 'Talabat Salary' },
      { Name: 'Delivero Commission' },
      { Name: 'Employee Per Day Salary' },
      { Name: 'General Expense' },
      { Name: 'Traffic Expense' }
    ];
    this.modeList = [
      { Name: 'Cash' },
      { Name: 'Cheque' },
      { Name: 'Bank Transfer' }
    ];
    this._MaxDateToday.setHours(this._MaxDateToday.getHours() + 5);
    let id = 21;
    this._clientService.getFormRestrictionByFormId(id).subscribe(
      (res: any) => {
        this.FormVm = res;
        this.FormVm.EndDate = new Date(res.EndDate);
        console.log(res);
      },
      (err) => {
        console.log(err);
      }
    );

    if((this.paymentMasterId != 0 && this.paymentMasterId != undefined)){
      debugger
      this._paymentsService.getPaymentMasterById(this.paymentMasterId).subscribe(
        (res: any) => {
          debugger
          this.paymentMaster = res;
          this.mast.FK_Account = new ItemViewModel(this.paymentMaster.FK_Account.Id);
          this.mast.FK_Payment = new ItemViewModel(this.paymentMaster.FK_PaymentAccount.Id);
          this.mast.CreatedDate = this.paymentMaster.CreatedDate;
          this.mast.CreatedBy = this.paymentMaster.Remarks;
          this.selectedMode = new ItemViewModel(this.paymentMaster.Mode,this.paymentMaster.Mode);
          if(this.paymentMaster.Type === "Payable"){
            this.isMate = true;
          }
          else{
            this.isMate = false;
          }
          
          this.Fetchdetail();
          this.NetAmount = this.paymentMaster.Amount;
          this.RemainingNetAmount = this.paymentMaster.Balance;
          this.RemainingNetAmountBackUp = this.paymentMaster.Balance;
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

public Cleardetail(){
  this.mast = new DuePaymentsViewModel();
  this.mast.CreatedDate = new Date();
  this.FromDate = null;
  this.ToDate = null;
  this.NetAmount = 0;
  this.RemainingNetAmount = 0;
  this.paymentList = [];
  this.selectedType = null;
  this.selectedMode = null;
  this.isMate = true;

}
  public handleSearchEvents() {
    this.searchSubcription = this.searchEvent
      .pipe(debounceTime(400))
      .subscribe((x: any) => {
        console.log(x);
        if (x) {
          if (x.filter == 'SCSC') {
            this.getAccount(x.event, 'SCSC')
          }
          if (x.filter == 'FK_Payment') {
            this.getAccount(x.event, 'CaB')
          }
        }
      });
  }

  public getAccount(x: string, event: string) {

    this._storeService.getAccountBySearch(x, event).subscribe(
      (res: any) => {
        if (res) {
          if(event == "SCSC")
          this.accountList = res;
          if(event == "CaB")
            this.supaccountList = res;
        }
      },
      (err) => {
        this._notificationService.notify(`danger`, err.msg);
      }
    );
  }

  public Fetchdetail() {
    debugger
    this.feachting = true;
    
    if (this.mast.FK_Account == undefined) {
      this.mast.FK_Account = new ItemViewModel();
    }
    if (this.selectedType == undefined) {
      this.mast.Type = "";
    }
    else {
      this.mast.Type = this.selectedType.Name;
    }
    this._paymentsService
      .getDuePaymentsForInstallments(this.mast.FK_Account.Id, this.FromDate, this.ToDate, this.mast.Type, this.isMate, this.invoiceId)
      .subscribe(
        (res: any) => {
          console.log(res);
          debugger
          this.paymentList = res.DtlList;
          this.paymentListCount = res.TotalCount;
          this.feachting = false;
        },
        (err) => { }
      );
  }

  public RemoveFromList(item) {
    debugger
    this.paymentList.splice(this.paymentList.indexOf(item), 1);
    this.RemainingNetAmount += item.Payment;
  }


  public FillPayment(id: number) {
    debugger;

    let paymentItem = this.paymentList.find(x => x.Id === id);

    if (!paymentItem) return;

    // If the payment is already fully filled, return
    if (paymentItem.Payment === paymentItem.Balance) {
      return;
    }

    // Recalculate the remaining amount before filling
    this.updateRemainingNetAmount();

    if (this.RemainingNetAmount > 0) {
      let fillableAmount = Math.min(this.RemainingNetAmount, paymentItem.Balance - (paymentItem.Payment || 0));

      paymentItem.Payment = (paymentItem.Payment || 0) + fillableAmount;
      this.RemainingNetAmount -= fillableAmount;
    } else {
      this.showError = true; // Show error if no balance left
    }
  }

  // Function to update RemainingNetAmount dynamically
  public updateRemainingNetAmount() {
    const totalPaid = this.paymentList.reduce((sum, item) => sum + (item.Payment || 0), 0);
    if(this.paymentMasterId == 0){
      this.RemainingNetAmount = this.NetAmount - totalPaid;

    }
    else{
      this.RemainingNetAmount = this.RemainingNetAmountBackUp - totalPaid;

    }
  }

  public updateValue(value: number) {
    this.RemainingNetAmount = value; // Example: Update it with some logic
    for (let i = 0; i < this.paymentList.length; i++) {
      this.paymentList[i].Payment = 0;
    }
    this.showError = false;
  }

  public updateAmount(payment,id) {
    debugger
    if(this.paymentMasterId == 0){
      const totalSum = this.paymentList.reduce((sum, item) => sum + (item.Payment || 0), 0);
      this.RemainingNetAmount = this.NetAmount - totalSum;
  
      let paymentItem = this.paymentList.find(x => x.Id === id);
      this.errorMessages[id] = payment > paymentItem.Balance;
    }
    else{
      const totalSum = this.paymentList.reduce((sum, item) => sum + (item.Payment || 0), 0);
      if(totalSum == 0){
        this.RemainingNetAmount = this.RemainingNetAmountBackUp;
      }
      else{
        this.RemainingNetAmount = this.RemainingNetAmountBackUp - totalSum;
        if(this.RemainingNetAmount < 0){
          this.errorMessages[id] = true;
        }
      }
      
  
      let paymentItem = this.paymentList.find(x => x.Id === id);
      this.errorMessages[id] = payment > paymentItem.Balance;
    }
    

  }
  public ClearForm() {
    this.mast = new DuePaymentsViewModel();
    //this.mast.FkCategory = new ItemViewModel();
    this.mast.CreatedDate = new Date();
    this.FromDate = null;
    this.ToDate = null;
    this.selectedType = null;
    this.selectedMode = null;
    this.paymentList = [];

  }

  public onSubmit() {
debugger
    if (this.NetAmount <= 0) {
      this.showError = true;
      return;
    }
    for (let i = 0; i < this.paymentList.length; i++) {
      this.paymentList[i].FK_PaymentMaster_Id = this.paymentMasterId;
      this.paymentList[i].NetAmount = this.NetAmount;
      this.paymentList[i].RemainingAmount = this.RemainingNetAmount;
      this.paymentList[i].CreatedBy = this.mast.CreatedBy;
      this.paymentList[i].CreatedDate = this.mast.CreatedDate;
      this.paymentList[i].FK_Payment = this.mast.FK_Payment;
      this.paymentList[i].Mode = this.selectedMode.Name;
    }
    //const totalPayment = this.paymentList.reduce((sum, element) => sum + (element.Payment || 0), 0);
    
    // if(totalPayment <= 0){
    //   this._notificationService.notify("danger", "Add payment.");
    //   return;
    // }
    //this.paymentList = this.paymentList.filter(x => x.Payment != null && x.Payment !== 0);
    this._paymentsService
      .addPaymentForInstallments(this.paymentList)
      .subscribe(
        (res: any) => {
          console.log(res);
          this.ClearForm();
          this._notificationService.notify(`success`, `Save Successfully!`);
        },
        (err) => {
          this._notificationService.notify("danger", err.error);
         }
      );
  }
}
